import { ChangeDetectionStrategy, Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [
    Location, {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent implements OnInit {

  location: any;
  langSelected: string;
  currentLang: string = 'tr';
  mobileMenuOpen = false;
  activeDropdown: string | null = null;
  activeSubDropdowns: { [key: string]: boolean } = {};
  private initialized = false;

  constructor(
    public router: Router,
    public apiService: ApiService,

    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private el: ElementRef,
    location: Location
  ) {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.location = this.router.url;
        }
      });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.openAllDropdowns();
        }, 1000);
      }
    });
  }
  @HostListener('window:scroll', [])


  ngOnInit(): void {
    // Detect language from URL
    const url = this.router.url;
    if (url.startsWith('/en')) {
      this.langSelected = 'en';
    } else {
      this.langSelected = 'tr';
    }
    this.currentLang = this.langSelected;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.initialized) {
          this.initialized = true;
          return;
        }
        this.closeAllDropdowns();
      }
    });


  }

  closeAllDropdowns(): void {
    const dropdowns = document.querySelectorAll('.dropdown-menu');
    dropdowns.forEach((dropdown: HTMLElement) => {
      this.renderer.setStyle(dropdown, 'visibility', 'hidden');
      this.renderer.setStyle(dropdown, 'opacity', '0');
    });
  }
  openAllDropdowns(): void {
    const dropdowns = document.querySelectorAll('.dropdown-menu');
    dropdowns.forEach((dropdown: HTMLElement) => {
      this.renderer.removeStyle(dropdown, 'visibility');
      this.renderer.removeStyle(dropdown, 'opacity');
    });
  }

  searchClassApplied = false;
  searchToggleClass() {
    this.searchClassApplied = !this.searchClassApplied;
  }


  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  toggleDropdown(dropdown: string) {
    this.activeDropdown = this.activeDropdown === dropdown ? null : dropdown;
  }

  toggleSubDropdown(subDropdown: string) {
    this.activeSubDropdowns[subDropdown] = !this.activeSubDropdowns[subDropdown];
  }

  closeMenu() {
    this.mobileMenuOpen = false;
    this.activeDropdown = null;
    this.activeSubDropdowns = {};
  }

}